import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/PersonList',
    name: 'PersonList',
    component: () => import('../views/PersonList.vue')
  },
  {
    path: '/BenefitCards',
    name: 'BenefitCards',
    component: () => import('../views/BenefitCards.vue')
  },
  {
    path: '/ExpiredBenefitCards',
    name: 'ExpiredBenefitCards',
    component: () => import('../views/ExpiredBenefitCards.vue')
  },
  {
    path: '/OrderList',
    name: 'OrderList',
    component: () => import('../views/OrderList.vue')
  },
  {
    path: '/',
    name: 'homePage',
    component: () => import('../views/homePage.vue')
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
